import React from 'react';
export const CardSkeleton = ({ kreeda }) => {
    return (React.createElement("div", { className: "card-item" },
        React.createElement("div", { className: "card-item__head" },
            React.createElement("div", { className: "card-item__head__heading" },
                React.createElement("div", { className: "h3__skeleton" }),
                React.createElement("div", { className: "text__skeleton" }),
                React.createElement("div", { className: "text__skeleton" }))),
        React.createElement("div", { className: "card-item__actions" },
            React.createElement("button", { className: "btn__skeleton--primary" }),
            React.createElement("button", { className: "btn__skeleton--secondary", disabled: kreeda.status === 'draft' }))));
};
